const DocumentMetadata = ({ title }: { title: string | null | undefined }) => {
  if (title) document.title = title;

  return null;
};

export default DocumentMetadata;
